import { memo } from 'react'

import { SearchOutlined } from '@material-ui/icons'

import Placeholder from '../Placeholder'

const NoSessionsFoundPlaceholder = () => {
  return <Placeholder icon={SearchOutlined} text='No sessions found...' />
}

export default memo(NoSessionsFoundPlaceholder)
